import api from "./api";
import API_URLS from "../../constants/api-urls";

export default class FarmerApi {
  createFarmerApi(farmeReq) {
    return api.post(API_URLS.URL.farmer, farmeReq);
  }

  getFarmerDetailsById(farmerId) {
    const getFarmerDetailsById = API_URLS.URL.getFarmerDetailsById.replace(
      ":farmer_id",
      farmerId,
    );
    return api.get(getFarmerDetailsById);
  }

  updateFarmerDetails(farmerId, farmerReq) {
    const updateFarmer = API_URLS.URL.updateFarmer.replace(
      ":farmer_id",
      farmerId,
    );
    return api.put(updateFarmer, farmerReq);
  }

  uploadFarmerPhoto(farmeReq) {
    return api.post(API_URLS.URL.uploadFarmerProfile, farmeReq);
  }

  getFarmerApi(farmeReq) {
    return api.post(API_URLS.URL.getFarmer, farmeReq);
  }

  createFarmInspection(inspectionReq) {
    return api.post(API_URLS.URL.farminspection, inspectionReq);
  }

  getFarmInspection(inspectionReq) {
    return api.post(API_URLS.URL.getInspectionList, inspectionReq);
  }

  createHarvesting(inspectionReq) {
    return api.post(API_URLS.URL.harvesting, inspectionReq);
  }

  getFarmHarvesting(harvestingReq) {
    return api.post(API_URLS.URL.getHarvestingReqList, harvestingReq);
  }

  updateFarmInspection(inspectionId, inspectionReq) {
    const updateFarmInspection = API_URLS.URL.updateFarminspection.replace(
      ":inspection_id",
      inspectionId,
    );
    return api.put(updateFarmInspection, inspectionReq);
  }

  // DELETE farminspection/{item_id}
  deleteFarmInspection(inspectionId) {
    return api.delete(
      API_URLS.URL.updateFarminspection.replace(":inspection_id", inspectionId),
    );
  }

  updateHarvesting(harvestingId, inspectionReq) {
    const updateFarmInspection = API_URLS.URL.updateHarvesting.replace(
      ":harvesting_id",
      harvestingId,
    );
    return api.put(updateFarmInspection, inspectionReq);
  }

  sendToFermentation(harvestingReq) {
    return api.post(API_URLS.URL.sendToFermentation, harvestingReq);
  }
}
